module.exports = __webpack_public_path__ + "static/img/introduction-2.67804da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduction-2.png
// module id = eBf8
// module chunks = 0